import { loader, spinnerInner } from './Loader.css'

const LoaderSize = {
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48,
} as const

export type LoaderProps = {
  size?: keyof typeof LoaderSize
}

export const Loader = ({ size = 'lg' }: LoaderProps) => (
  <div className={loader[size]}>
    <div className={spinnerInner} />
    <div className={spinnerInner} />
    <div className={spinnerInner} />
    <div className={spinnerInner} />
  </div>
)
